import type { AppDefinition } from '../types';
import { AppCard } from './AppCard';

export interface AppGridProps {
  apps: AppDefinition[];
  showStar: boolean;
  isFav: (id: string) => boolean;
  onToggleFav: (id: string) => void;
}

export function AppGrid({ apps, showStar, isFav, onToggleFav }: AppGridProps) {
  return (
    <div className="grid gap-2 [grid-template-columns:repeat(auto-fill,minmax(80px,96px))]">
      {apps.map((app, i) => (
        <AppCard
          key={app.id}
          app={app}
          showStar={showStar}
          isFav={isFav(app.id)}
          onToggleFav={() => onToggleFav(app.id)}
          index={i}
        />
      ))}
    </div>
  );
}
